import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useDialogContext } from '@avanta/shared/contexts/Dialog';
import { cn } from '@avanta/shared/utils/cn';
import { MessageCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import ChatBannerImage from 'assets/home/CHAT-PSICOLOGICO-IMG.webp';
import { ChatStartConfirmDialog } from 'components/ChatStartConfirmDialog';
import { Banner } from 'components/ui/Banner';
import { PSYCHOLOGIST_ID } from 'constants/chat';
import { ROUTES } from 'constants/routes';
import { useComponentTracking } from 'tracking/hooks/useTrackingComponent';

interface ChatBannerProps {
  className?: string;
  hideImage?: boolean;
}

export const ChatBanner = ({
  className,
  hideImage = false,
}: ChatBannerProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.CHAT);
  const navigate = useNavigate();
  const { showDialog } = useDialogContext();
  const { trackEmotionalSupportChatStart } = useComponentTracking();

  const handleStartChat = (): void => {
    showDialog({
      component: (
        <ChatStartConfirmDialog
          onConfirm={async () => {
            await trackEmotionalSupportChatStart({ supporterId: PSYCHOLOGIST_ID });
            navigate(ROUTES.CHAT, { state: { psychologist: true } });
          }}
        />
      ),
    });
  };

  return (
    <Banner
      className={cn('am-lg:p-0 p-0', className)}
      title={t('ChatBanner.heading')}
      icon={MessageCircle}
      buttonProps={{
        variant: 'secondary',
        label: t('ChatBanner.cta'),
        onClick: handleStartChat,
        notificationUserId: PSYCHOLOGIST_ID,
      }}
      description={t('ChatBanner.body')}
      {...(!hideImage && { image: ChatBannerImage })}
    />
  );
};
